<template>
  <date-range-custom-plugin
    :initRange="dateRange"
    :captions="captions"
    :months="months"
    :shortDays="shortDays"
    :format="format"
    :righttoleft="true"
    :hasDateToUse="hasDateToUse"
    :initDateToUse="dateToUse"
    :dateToUseOptions="dateToUseOptions"
    @applyrange="applyRange"
    @cleardaterange="resetRange"
  />
</template>

<script>
import DateRangeCustomPlugin from "./DateRangeCustomPlugin";
import dayjs from "dayjs";

export default {
  components: {
    DateRangeCustomPlugin
  },
  props: {
    storeType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      months: [
        this.$t("baseFilters.datePicker.months.january"),
        this.$t("baseFilters.datePicker.months.february"),
        this.$t("baseFilters.datePicker.months.march"),
        this.$t("baseFilters.datePicker.months.april"),
        this.$t("baseFilters.datePicker.months.may"),
        this.$t("baseFilters.datePicker.months.june"),
        this.$t("baseFilters.datePicker.months.july"),
        this.$t("baseFilters.datePicker.months.august"),
        this.$t("baseFilters.datePicker.months.september"),
        this.$t("baseFilters.datePicker.months.october"),
        this.$t("baseFilters.datePicker.months.november"),
        this.$t("baseFilters.datePicker.months.december")
      ],
      shortDays: [
        this.$t("baseFilters.datePicker.shortDays.sunday"),
        this.$t("baseFilters.datePicker.shortDays.monday"),
        this.$t("baseFilters.datePicker.shortDays.tuesday"),
        this.$t("baseFilters.datePicker.shortDays.wednesday"),
        this.$t("baseFilters.datePicker.shortDays.thursday"),
        this.$t("baseFilters.datePicker.shortDays.friday"),
        this.$t("baseFilters.datePicker.shortDays.saturday")
      ],
      captions: {
        title: this.$t("baseFilters.datePicker.title"),
        ok_button: this.$t("baseFilters.datePicker.actionBtn")
      },
      format: "DD/MM/YYYY"
    };
  },
  created() {},
  methods: {
    initialize() {},
    constructDate(date) {
      // dayjs()
      //    .utc()
      //   .year(this.activeYearStart)
      //   .month(this.activeMonthStart)
      //   .startOf('month')
      //   .day()
      return new Date(
        Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0)
      );
    },
    addRange(label, active, dateRange) {
      return {
        label: label,
        active: active,
        dateRange: dateRange
      };
    },
    applyRange(dateRange, dateToUse) {
      const DATE_FORMAT = "YYYY-MM-DD";
      if (this.hasDateToUse) {
        this.$store.commit(`${this.storeType}/updateDateToUse`, dateToUse);
      }
      this.updateDateRange({
        dateFrom: dateRange.start
          ? dayjs(dateRange.start).format(DATE_FORMAT)
          : null,
        dateTo: dateRange.end ? dayjs(dateRange.end).format(DATE_FORMAT) : null
      });
    },
    resetRange() {
      this.updateDateRange({
        dateFrom: null,
        dateTo: null
      });
    },
    updateDateRange(dateRange) {
      this.$store.commit(`${this.storeType}/updateDateRange`, dateRange);
      this.$emit("retrieveitems");
    }
  },
  computed: {
    dateRange() {
      let storeDateRange = this.$store.getters[`${this.storeType}/dateRange`];
      if (
        storeDateRange &&
        (storeDateRange.dateFrom || storeDateRange.dateTo)
      ) {
        let dateRange = {
          start: null,
          end: null
        };
        if (storeDateRange.dateFrom)
          dateRange.start = this.constructDate(
            dayjs(storeDateRange.dateFrom).toDate()
          );
        if (storeDateRange.dateTo)
          dateRange.end = this.constructDate(
            dayjs(storeDateRange.dateTo).toDate()
          );
        return dateRange;
      } else return null;
    },
    hasDateToUse() {
      // fondoest-nest#62: both 'booking' and 'request' types now use dateToUseConfig with options 'schedule' and 'request'
      return true;
    },
    dateToUse() {
      if (this.hasDateToUse)
        return this.$store.getters[`${this.storeType}/dateToUse`];
      else return "";
    },
    dateToUseOptions() {
      if (this.hasDateToUse)
        return this.$store.getters[`${this.storeType}/dateToUseOptions`];
      else return [];
    }
  }
};
</script>

<style scoped>
.calendar_days_selected {
  background: red !important;
}
</style>
